import { render } from "./ContributionList.vue?vue&type=template&id=6e24882d"
import script from "./ContributionList.vue?vue&type=script&lang=js"
export * from "./ContributionList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__